module.exports = __webpack_public_path__ + "img/momo_index_bg_top.3b663ec9.png";